import sharedStore from '@shared/store';

import passwordreset, { MODULE_NAME as passwordresetName } from './passwordreset';

sharedStore.registerModule(passwordresetName, passwordreset);

export default sharedStore;



// WEBPACK FOOTER //
// ./login/store/index.js